import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { RadioGroup } from '#app/components/ui/radio-group'
import { haversineDistance } from '#app/utils/calculate-distance'
import { type PlentyVariantAvailability } from '#types/product'
import RadioOption from './radio-option'

const RadioGroupStores = ({
	stores,
	name,
	onSelectChannel,
	selectedChannelKey,
	mapCenter,
}: {
	stores: PlentyVariantAvailability[]
	name: string
	onSelectChannel: (channelKey: string) => void
	selectedChannelKey: string
	mapCenter: google.maps.LatLngLiteral
}) => {
	const { t } = useTranslation('shopping_bag')
	const [selectedKey, setSelectedKey] = useState(selectedChannelKey)
	const [sortedStores, setSortedStores] = useState(stores)

	useEffect(() => {
		setSelectedKey(selectedChannelKey)
	}, [selectedChannelKey])

	const handleChange = (channelKey: string) => {
		setSelectedKey(channelKey)
		onSelectChannel(channelKey)
	}

	useEffect(() => {
		// Sort stores by distance to the mapCenter
		const sorted = [...stores].sort((a, b) => {
			const distanceA = haversineDistance(mapCenter, {
				lat: a.geoLocation!.coordinates[0],
				lng: a.geoLocation!.coordinates[1],
			})
			const distanceB = haversineDistance(mapCenter, {
				lat: b.geoLocation!.coordinates[0],
				lng: b.geoLocation!.coordinates[1],
			})
			return distanceA - distanceB
		})
		setSortedStores(sorted)
	}, [mapCenter, stores])

	return (
		<div className="flex max-h-96 flex-col overflow-y-auto md:max-h-full ">
			<RadioGroup
				className="gap-0"
				value={selectedKey}
				name={name}
				aria-label="Radio Buttons for Stores"
				onValueChange={handleChange}
			>
				{sortedStores.map((store: PlentyVariantAvailability) => {
					const address = `${store.storeAddress?.streetName} ${store.storeAddress?.streetNumber}, ${store.storeAddress?.postalCode} ${store.storeAddress?.city}`

					return (
						<RadioOption
							stock={store.availableQuantity}
							key={store.channelKey}
							id={store.channelKey as string}
							name={store.storeName ?? t('common:unknown')}
							address={address}
							selected={store.channelKey === selectedKey}
						/>
					)
				})}
			</RadioGroup>
		</div>
	)
}

export default RadioGroupStores
